import React from 'react'
import styles from './ManualNav.module.css';
import List from '../List';
import ManualNavItem from '../ManualNavItem'
import {NavAccordion} from './NavAccordion';

const ManualNav = props => {

  const {navLevel = 0} = props;

  const list = (
    <List className={styles.ManualNav}>
      {props.pagelist.length > 0 ? props.pagelist.map( id => <ManualNavItem key={id} id={id} {...props} />) : null } 
    </List>
  );

  // Only the outermost nav owns the shared one-open-section state. Nested navs
  // read the provider above them rather than shadowing it with a second one.
  return navLevel > 0 ? list : <NavAccordion>{list}</NavAccordion>;
}

export default ManualNav
